import React from 'react';
import { FaLightbulb } from "react-icons/fa6";

const Hints = ({ title, message, linkText, email }) => {
  if (!title && !message && !linkText && !email) return null;
  return (
 <div className="mt-6 max-w-[90%] sm:max-w-[500px] mx-auto shadow-[0px_4px_4px_#00000040] border-l-[4px] border-l-[#1B365D] bg-[#1B365D0D] rounded-[4px] p-[25px] flex">
      <FaLightbulb className=" text-[30px]" />
      <div className="ms-3 ">
        {title && <h6 className="font-bold mb-2">{title}</h6>}
        {message && <p className="leading-[16px] tracking-[0] ">{message}</p>}
        {email && linkText && (
          <a href={`mailto:${email}`} className="font-bold text-[#E76F51] block mt-2">
            {linkText}
          </a>
        )}
      </div>
    </div>
  );
};

export default Hints;
